import { BaseResponse, request, tryResponse } from "@/lib/request";
import { Tag } from "@/types";
export interface TagResponse {
	total: number;
	list: Tag[];
}

export const listTag = async (): Promise<BaseResponse<TagResponse>> => {
	return request.get("/aifk/creation/tag/list");
};

export const getCreation = async (
	creationId: string,
): Promise<BaseResponse<any>> => {
	return request.get("/aifk/creation/detail", {
		creationId,
	});
};

export const createCreation = async (data: any): Promise<any> => {
	return request.post("/aifk/creation/create", data);
};

export const updateCreation = async (data: any): Promise<BaseResponse<any>> => {
	return request.post("/aifk/creation/update", data);
};

export const publishCreation = async (
	creationId: string,
): Promise<BaseResponse<any>> => {
	return request.post("/aifk/creation/publish", {
		creationId,
	});
};

export const refreshPreviewDialogue = async (
	creation_id: string,
): Promise<BaseResponse<any>> => {
	return request.post("/aifk/dialogue/refresh_preview", {
		creation_id,
	});
};

export const getPreviewDialogue = async (
	creation_id: string,
): Promise<BaseResponse<any>> => {
	return request.get("/aifk/dialogue/get_preview", {
		creation_id,
	});
};
